import { Alert, BtnClasses, Button, Empty, Spinner } from '@tcweb/connect-ui';
import { t } from '@trimble/i18n';
import { Component, Show } from 'solid-js';

import { CurrentWorkspaceBar } from './CurrentWorkspaceBar';
import { FX_WORKSPACE_LAYERS_ICON } from './FxWorkspaceEmptyState';
import { WorkspacesTabActiveWorkspace } from './WorkspacesTabActiveWorkspace';
import type { WorkspacesTabPanelContentProps } from './WorkspacesTabPanelContent.types';

export const WorkspacesTabPanelContent: Component<
  WorkspacesTabPanelContentProps
> = (props) => (
  <div class="flex h-full min-h-0 flex-col">
    {/* Outside the error/loading gates so the user can switch away from a workspace whose details fail or load. */}
    <Show when={props.activeWorkspace}>
      {(workspace) => (
        <CurrentWorkspaceBar
          workspaceOptions={props.workspaceOptions}
          activeWorkspaceId={workspace().id}
          onActiveWorkspaceChange={props.onActiveWorkspaceChange}
          onCreateWorkspace={props.onCreateWorkspace}
        />
      )}
    </Show>
    <div class="min-h-0 flex-1">
      <Show
        when={!props.isError}
        fallback={
          <div class="flex flex-col items-start gap-2">
            <Alert type="error">
              {t('mobileMapping.fxWorkspace.loadFailed')}
            </Alert>
            {/* List failure has no active workspace, so the bar with Create New does not mount. */}
            <Show when={!props.activeWorkspace}>
              <Button
                color={BtnClasses.PRIMARY}
                data-testid="create-workspace-button"
                onClick={props.onCreateWorkspace}
              >
                {t('mobileMapping.fxWorkspace.createWorkspace')}
              </Button>
            </Show>
          </div>
        }
      >
        <Show
          when={!props.isLoading}
          fallback={
            <div class="h-[300px]">
              <Spinner show={true} />
            </div>
          }
        >
          <Show
            when={props.hasWorkspaces}
            fallback={
              <Empty
                icon={FX_WORKSPACE_LAYERS_ICON}
                title={t('mobileMapping.fxWorkspace.title')}
                message={t('mobileMapping.fxWorkspace.noWorkspaces')}
                class="flex-1 w-100"
                backgroundColorClass="bg-white"
                textColorClass="text-base-content"
                data-testid="workspaces-no-data-found"
                isSmallContainer={true}
                content={
                  <modus-wc-button
                    color="primary"
                    shape="rectangle"
                    size="md"
                    type="button"
                    variant="filled"
                    data-testid="create-workspace-empty-button"
                    onClick={props.onCreateWorkspace}
                  >
                    {t('mobileMapping.fxWorkspace.createWorkspace')}
                  </modus-wc-button>
                }
              />
            }
          >
            <Show when={props.activeWorkspace}>
              {(workspace) => (
                <WorkspacesTabActiveWorkspace
                  workspace={workspace()}
                  hasWorkspaceReferences={props.hasWorkspaceReferences}
                  nodes={props.nodes}
                  childrenLoadStatus={props.childrenLoadStatus}
                />
              )}
            </Show>
          </Show>
        </Show>
      </Show>
    </div>
  </div>
);
